import React, {memo, useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import Button from "../../components/Button";
import {MdOutlineDataSaverOff} from "react-icons/md";
import {getFetchData} from "../../services/supplierService";
import {useSelector} from "react-redux/es/exports";
import ComboboxComponent from "../../components/Combobox";
import {getItem, getList} from "../../services/service";
import {useNavigate} from "react-router-dom";


const ProfileSystemFillingLayout = ({treeSelectId, t}) => {
    const [isLoading, setIsLoading] = useState(false);
    const {token} = useSelector((state) => state.user);
    const [suppliers, setSuppliers] = useState([]);
    const [glassId, setGlassId] = useState(null);
    const [fillingId, setFillingId] = useState(null);
    const [productList, setProductList] = useState([]);
    const [fillingList, setFillingList] = useState([]);
    const handleSubmit = async (evt) => {

    };

    const fetchSuppliersList = async () => {
        const responce = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/supplier/list`,
            token
        );
        if (responce.success) {
            setSuppliers(responce.data)
        }
    }


    useEffect(() => {
        fetchSuppliersList();
        fetchDataProduct().then(() => fetchDataById())
        fetchFillingList();
    }, [treeSelectId])


    const fetchDataProduct = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/product/article/filling`,
            token
        );
        if (response.success) {
            setProductList(response.data);
        }
    };
    const fetchFillingList = async () => {
        const response = await getList(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/filling/group/list`,
            token
        );
        if (response.success) {
            setFillingList(response.data);
        }
    }

    const fetchDataById = async () => {
        if (!treeSelectId) return;
        const response = await getItem(
            `${process.env.REACT_APP_HOST_BASE_URL}/v1/profile/system/${treeSelectId}`,
            token
        );
        if (response.success) {
            // setName(response.data.name);
            setGlassId(response.data.defaultGlassId);
            setFillingId(response.data.fillingGroupId);
        }
    };

    function handleChangeProduct(value) {
        setGlassId(value.id);
    }

    function handleChangeFilling(value) {
        setFillingId(value.id);
    }
    return (
        <>
            <h1 className="mb-5 text-xl font-semibold text-gray-900">
                {t('profile_system_default_filling')}
            </h1>
            <form onSubmit={handleSubmit}>
                <div className="shadow sm:rounded-md">
                    <div className="px-4 py-5 bg-white sm:p-6">
                        <div className="grid grid-cols-6 gap-6">
                            <div className="col-span-6 sm:col-span-3">
                                <ComboboxComponent
                                    label={t('DOUBLE_GLAZING')}
                                    data={productList}
                                    item={glassId ?
                                        productList.find(
                                            (item) => item.id === glassId
                                        )
                                        : null}
                                    onChange={handleChangeProduct}
                                />
                            </div>
                            <div className="col-span-6 sm:col-span-3">
                                <ComboboxComponent
                                    label={t('profile_system_default_filling')}
                                    data={fillingList}
                                    value={fillingId}
                                    item={fillingId ?
                                        fillingList.find(
                                            (item) => item.id === fillingId
                                        )
                                        : null}
                                    onChange={handleChangeFilling}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </>
    );
};
export default withTranslation()(memo(ProfileSystemFillingLayout));